<script>
import baseMixin from '@/mixins/baseMixin'
import fileMixin from '@/mixins/fileMixin'
import DownloadedFile from '@/models/file/downloadedFile'
import FileNotFoundBlock from './file-not-found-block.vue'
import FileUnableToPreviewBlock from './file-unable-to-preview-block.vue'

export default {
  name: 'FilePreviewContainer',
  components: {
    FileUnableToPreviewBlock,
    FileNotFoundBlock,
  },
  mixins: [baseMixin, fileMixin],
  props: {
    file: { type: DownloadedFile, default: null },
    loading: { type: Boolean, default: false },
  },
  data: () => {
    return {
      rerender: false,
    }
  },
  computed: {
    fileType() {
      return this.file.file.type
    },
    isAnImage() {
      const type = this.fileType
      if (!type) return false
      return type.includes('image')
    },
    isUnsupportedFileType() {
      return this.isNotSupported(this.fileType)
    },
    compBlobUrl() {
      if (this.file?.file) {
        return URL.createObjectURL(this.file.file)
      } else {
        return null
      }
    },
  },
  watch: {
    compBlobUrl: {
      async handler() {
        this.rerender = true
        await this.$nextTick()
        this.rerender = false
      },
    },
  },
  methods: {
    retryDownload() {
      this.$emit('retry')
    },
    documentDownloaded() {
      this.$emit('download')
    },
  },
}
</script>

<template>
  <section v-if="!rerender" class="w-100 h-100">
    <div v-if="loading" class="d-flex align-center justify-center h-100">
      <v-progress-circular
        data-testid="file-preview-container-loading-indicator"
        indeterminate
        color="white"
        size="64"
      ></v-progress-circular>
    </div>
    <article
      v-else-if="!compBlobUrl"
      class="d-flex align-center justify-center h-100"
    >
      <FileNotFoundBlock
        data-testid="file-preview-container-file-not-found-block"
        @retry="retryDownload"
      />
    </article>
    <article v-else-if="isUnsupportedFileType">
      <FileUnableToPreviewBlock
        data-testid="file-preview-container-unable-to-preview-block"
        :blob-url="compBlobUrl"
        @download="documentDownloaded"
      />
    </article>
    <article
      v-else
      class="d-flex flex-column w-100 h-100 justify-center align-center"
    >
      <v-img
        v-if="isAnImage"
        data-testid="file-preview-container-image-preview"
        max-height="80vh"
        contain
        :src="compBlobUrl"
      />
      <!-- HACK: Disable preview in mobile devices and let them download -->
      <FileUnableToPreviewBlock
        v-else-if="isSmallOrLower"
        data-testid="file-preview-container-unable-to-preview-block-viewport"
        :blob-url="compBlobUrl"
        @download="documentDownloaded"
      />
      <iframe
        v-else
        data-testid="file-preview-container-iframe-preview"
        style="width: 90vw; height: 90vh"
        frameborder="0"
        :src="compBlobUrl"
      />
    </article>
  </section>
</template>
